import { CButton, CCol, CInput, CLabel, CRow } from "@coreui/react";
import React from "react";
import Auth from "src/auth";
import { useHistory } from "react-router-dom";
import { formatDate } from "src/shared/Format/dateFormat";

const LotListViewTransferDetails = (props) => {
  const { authenticated } = Auth();
  let history = useHistory();
  return (
    <>
      <CRow className="pt-3 mt-3">
        <CCol xl={12}>
          <h3 className="titlehr">Transfer Details</h3>
        </CCol>
      </CRow>
      {props.viewTransferDetails.map((data, key) => (
        <div className="pl-1 pr-1">
          <>
            {/* {"key bal: " + key} */}
            {key === 0 ? (
              <>
                <CRow className="mt-1">
                  {authenticated.userId !== data.transferFromUserId && (
                    <CCol className="mb-2" xl={3}>
                      <CLabel
                        htmlFor="exampleFormControlInput1"
                        key={`label${key}`}
                      >
                        Transferor :
                      </CLabel>
                      <br />
                      {/* <CLabel
                    htmlFor="exampleFormControlInput1"
                    key={`labelValue${key}`}
                  >
                    <b>
                      {data.transferFromUser === null
                        ? " "
                        : data.transferFromUser}
                    </b>
                  </CLabel> */}
                      <CInput
                        key={`Transfer from user${key}`}
                        value={
                          data.transferFromUser === null
                            ? " "
                            : data.transferFromUser
                        }
                        disabled
                        id="exampleFormControlInput1"
                      />
                    </CCol>
                  )}
                  <CCol className="mb-2" xl={3}>
                    <CLabel
                      key={`label Transfer to user${key}`}
                      htmlFor="exampleFormControlInput1"
                    >
                      Transferee :
                    </CLabel>
                    <CInput
                      key={`Transfer to user${key}`}
                      value={
                        data.transferToUser === null ? " " : data.transferToUser
                      }
                      disabled
                      id="exampleFormControlInput1"
                    />
                  </CCol>
                  <CCol className="mb-2" xl={2}>
                    <CLabel
                      key={`label Request Date${key}`}
                      htmlFor="exampleFormControlInput1"
                    >
                      Request Date :
                    </CLabel>
                    <CInput
                      key={`Request Date${key}`}
                      value={
                        data.requestDateTime === null
                          ? " "
                          : formatDate(data.requestDateTime)
                      }
                      disabled
                      id="exampleFormControlInput1"
                    />
                  </CCol>
                  <CCol className="mb-2" xl={2}>
                    <CLabel
                      key={`label Request Update Date${key}`}
                      htmlFor="exampleFormControlInput1"
                    >
                      Update Date :
                    </CLabel>
                    <CInput
                      key={`Request Update Date${key}`}
                      value={
                        data.requestUpdateDateTime === null
                          ? " "
                          : formatDate(data.requestUpdateDateTime)
                      }
                      disabled
                      id="exampleFormControlInput1"
                    />
                  </CCol>
                  <CCol className="mb-2" xl={1}>
                    <CLabel
                      key={`label span${key}`}
                      htmlFor="exampleFormControlInput1"
                    >
                      Status :
                    </CLabel>
                    <h5>
                      {data.status === null ? (
                        " "
                      ) : data.status === 0 ? (
                        <span
                          key={`pending-span${key}`}
                          className="badge bg-warning text-dark"
                        >
                          Pending
                        </span>
                      ) : data.status === 1 ? (
                        <span
                          key={`Accepted-span${key}`}
                          className="badge bg-success text-light"
                        >
                          Accepted
                        </span>
                      ) : (
                        <span
                          key={`Rejected-span${key}`}
                          className="badge bg-danger text-light"
                        >
                          Rejected
                        </span>
                      )}
                    </h5>
                  </CCol>
                  <CCol className="mb-2" xl={1}>
                    <CLabel
                      key={`label approveduser span${key}`}
                      htmlFor="exampleFormControlInput1"
                    >
                      User Approved:
                    </CLabel>
                    <h5>
                      {data.isUserApproved === null ? (
                        <span
                          key={`pending-span${key}`}
                          className="badge bg-warning text-dark"
                        >
                          Pending
                        </span>
                      ) : data.isUserApproved === true ? (
                        <span
                          key={`Accepted-span${key}`}
                          className="badge bg-success text-light"
                        >
                          Accepted
                        </span>
                      ) : (
                        <span
                          key={`Rejected-span${key}`}
                          className="badge bg-danger text-light"
                        >
                          Rejected
                        </span>
                      )}
                    </h5>
                  </CCol>
                  <CCol className="mb-2" xl={12}>
                    <CLabel
                      key={`label comment${key}`}
                      htmlFor="exampleFormControlInput1"
                    >
                      Comment : {data.comments}
                    </CLabel>
                  </CCol>
                </CRow>
                <CRow className="mt-2">
                  {/* {props.viewListDetails.lottransferpaymentdecription ===
              null ||
            props.viewListDetails.lottransferpaymentdecription === */}
                  {props.viewListDetails.isTransferFeePaidStatusSuccess ===
                  false ? (
                    ""
                  ) : (
                    <>
                      {data.status !== 1 ? (
                        ""
                      ) : (
                        <>
                          <CCol xl={12}>
                            <h5 className="titlehr">
                              Lot Transfer Fee Receipt
                            </h5>
                          </CCol>

                          <CCol xl={6} className={"mt-1"}>
                            {
                              props.viewListDetails
                                ?.lottransferpaymentdecription
                            }
                          </CCol>
                          <CCol xl={2}>
                            {props.viewListDetails.islottransferpaymentBG ===
                            true ? (
                              // <a
                              //   target="_blank"
                              //   href={`${downloadUrl}/${props.viewListDetails.lottransferpaymentidBGpath}`}
                              //   rel="noreferrer"
                              // >
                              <CButton
                                color="info"
                                className="mr-5 float-right mt-1"
                                onClick={() =>
                                  props.BGPaymentStatusViewHanlder(
                                    props.viewListDetails
                                      .lottransferpaymentidBGpath
                                  )
                                }
                              >
                                View BG
                              </CButton>
                            ) : (
                              // </a>
                              <CButton
                                color="info"
                                hidden={data.status !== 1 ? true : false}
                                onClick={() =>
                                  props.PaymentStatusViewHanlder(
                                    props.viewListDetails
                                      .lottransferpaymentranId
                                  )
                                }
                                className="mr-5 mt-1 float-right"
                              >
                                View Receipt
                              </CButton>
                            )}
                          </CCol>
                        </>
                      )}
                    </>
                  )}
                  {/* Pay Transfer Fees */}
                  {/* {"IsTransferFees_EMD_Visible : " + props.viewListDetails.isTransferFees_EMD_Visible } */}
                  {data.isUserApproved === true &&
                  authenticated.role === "Bidder" &&
                  props.viewListDetails.isTransferFees_EMD_Visible ? (
                    <>
                      {data?.status === 1 &&
                      data.transferToUserId === authenticated.userId &&
                      data?.approvedByUserId !== null &&
                      (props.viewPaymentDetails.length === 0 ||
                        (props.viewPaymentDetails.length > 0 &&
                          props.viewPaymentDetails[
                            props.viewPaymentDetails.length - 1
                          ].status === 2)) ? (
                        props.viewListDetails.isTransferFeePaidStatusSuccess ===
                        false ? (
                          // props.viewListDetails.lottransferpaymentdecription ===
                          //   null ||
                          // props.viewListDetails.lottransferpaymentdecription === ""
                          <>
                            <CCol xl={6}>
                              <strong>
                                Amount : {props.viewListDetails.lotTransferFee}
                              </strong>
                            </CCol>
                            <CCol xl={2}>
                              <CButton
                                onClick={() => {
                                  const location = {
                                    pathname: `/selectpaymentmethod/${data.lotTransferId}`,
                                    state: {
                                      lotId: props.decrypted,
                                    },
                                  };

                                  history.push(location);
                                }}
                                color="info"
                              >
                                Pay Transfer Fee
                              </CButton>
                            </CCol>
                          </>
                        ) : (
                          <>
                            {/* <strong>Lot Transfer Fee Receipt</strong>
                    <hr></hr>
              <CRow>
                  <CCol xl={6}>

                  {props.viewListDetails?.lottransferpaymentdecription}
                  </CCol>
                  <CCol xl={2}>
                  {(props.viewListDetails.islottransferpaymentBG == true)
                  ?
                  (
                  <a target="_blank" href={`${downloadUrl}/${props.viewListDetails.lottransferpaymentidBGpath}`}>
                  <CButton
                      color="info"
                      className="mr-5 mt-1 float-right"
                    >
                      View BG
                  </CButton>
                  </a>
                  )
                  :
                  (
                    <CButton
                    color="info"
                    onClick={() =>
                      props.PaymentStatusViewHanlder(props.viewListDetails.lottransferpaymentranId)
                    }
                    className="mr-5 mt-1 float-right"
                  >
                    View Receipt
                  </CButton>
                  )}

                  </CCol>
                </CRow> */}
                          </>
                        )
                      ) : (
                        ""
                      )}
                    </>
                  ) : data.isUserApproved === true &&
                    authenticated.role === "Bidder" &&
                    props.viewListDetails.isTransferFees_EMD_Visible &&
                    props.viewTransferDetails[
                      props.viewTransferDetails.length - 1
                    ].approvedByUserId !== 0 &&
                    props.viewTransferDetails[
                      props.viewTransferDetails.length - 1
                    ].transferFromUserId === authenticated.userId &&
                    props.viewPaymentDetails &&
                    props.viewPaymentDetails[key] &&
                    props.viewPaymentDetails[key]?.status === 2 ? (
                    <CCol className="mb-2" xl={2}>
                      <CButton
                        className="mt-4"
                        onClick={() => {
                          const location = {
                            pathname: `/selectpaymentmethod/${data.lotTransferId}`,
                            state: {
                              lotId: props.decrypted,
                            },
                          };

                          history.push(location);
                        }}
                        color="info"
                      >
                        Pay Transfer Fee
                      </CButton>
                    </CCol>
                  ) : data.isUserApproved === true &&
                    authenticated.role === "Bidder" &&
                    props.viewListDetails.isTransferFees_EMD_Visible &&
                    props.viewTransferDetails[
                      props.viewTransferDetails.length - 1
                    ].approvedByUserId !== 0 &&
                    props.viewTransferDetails[
                      props.viewTransferDetails.length - 1
                    ].transferFromUserId === authenticated.userId &&
                    props.viewPaymentDetails &&
                    props.viewPaymentDetails[key]?.filePath === null ? (
                    <CCol className="mb-2" xl={2}>
                      <CButton
                        className="mt-4"
                        // to={`/selectpaymentmethod/${data.lotTransferId}`}
                        onClick={() => {
                          const location = {
                            pathname: `/selectpaymentmethod/${data.lotTransferId}`,
                            state: {
                              lotId: props.decrypted,
                            },
                          };

                          history.push(location);
                        }}
                        color="info"
                      >
                        Pay Transfer Fee
                      </CButton>
                    </CCol>
                  ) : (
                    ""
                  )}
                </CRow>
              </>
            ) : (
              ""
            )}
          </>
        </div>
      ))}
    </>
  );
};

export default LotListViewTransferDetails;
